import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import get from 'lodash/get'
import { authSelector, teamSelector, employeeSelector } from './../../../selectors'
import { teamAction, employeeAction } from './../../../actions/'
import CustomTable from '../../../components/table'

const header = ['Start Date', 'Team ID', 'Team Name', 'Modified By']

class ListTeam extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      teams: [],
    }
    this.handleClickEdit = this.handleClickEdit.bind(this)
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.listTeam(access_token)
    this.props.getEmployeeList(access_token)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.listTeamData) {
      this.setState({ teams: nextProps.listTeamData })
    }
  }
  handleClickEdit(id) {
    this.props.handleClickEdit(true, id)
    this.props.handleSpan(true)
  }
  render() {
    const IsAdminUser = get(this.props, 'authData.user.is_hr_admin_role')
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsHRConfidentialUser = get(this.props, 'authData.user.is_hr_admin_confidential_role')
    const IsManagementUser = get(this.props, 'authData.user.is_management_role')

    if (IsHRConfidentialUser !== undefined &&
      IsSystemUser !== undefined &&
      IsAdminUser !== undefined &&
      IsManagementUser !== undefined &&
      !(IsHRConfidentialUser || IsSystemUser || IsAdminUser || IsManagementUser)) window.location = '/home'

    return (
      /* eslint no-underscore-dangle: 0 */
      <CustomTable
        header={ header }
        data={ this.props.teams }
        handleClickEdit={ this.handleClickEdit }
        span={ get(this.props, 'span') }
        table={ this.props.table }
        employeeList={ this.props.employeeList }
      />
    )
  }
}

ListTeam.propTypes = {
  listTeam: PropTypes.func.isRequired,
  listTeamData: PropTypes.array,
  handleClickEdit: PropTypes.func.isRequired,
  handleSpan: PropTypes.func.isRequired,
}
ListTeam.defaultProps = {
  listTeamData: [],
}
const mapStateToProps = (state, props) => createStructuredSelector({
  listTeamData: teamSelector.getListTeam,
  teamDeactivate: teamSelector.getDeactivateTeamData,
  redirectTeam: teamSelector.redirectTeam,
  authData: authSelector.getAuth,
  employeeList: employeeSelector.getListUser,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  listTeam: teamAction.getTeam,
  deactivateTeam: teamAction.deactivateTeam,
  resetDeactivateTeam: teamAction.resetDeactivateTeam,
  resetListTeam: teamAction.resetListTeam,
  getEmployeeList: employeeAction.getUser,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ListTeam)



// WEBPACK FOOTER //
// ./src/pages/team/list/index.js